import { useMutation } from "react-query";
import { createAreaOfConcern } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useCreateAreaOfConcern = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createAreaOfConcern(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while adding the area of concern.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    createAreaOfConcernMutation: mutate,
    isCreateAreaOfConcernLoading: isLoading,
    ...rest,
  };
};

export default useCreateAreaOfConcern;
